import { createComponent } from '@carvana/vdp-components';
import { withErrorBoundary } from '@/ErrorBoundary';
import { TileData, TileDataContextProvider } from '~/contexts/TileDataContext';
import FirstRow from './FirstRow';
import PricingAndTerms from './PricingAndTerms';
import ShippingAndGetItBy from './ShippingAndGetItBy/ShippingAndGetItBy';
import SkeletonTile from './SkeletonTile/SkeletonTile';
import TileContainer from './TileContainer';
import VehicleYMMTM from './VehicleYMMTM';

const TileContent = createComponent('div', {
  className:
    'grid grid-cols-1 grid-rows-[44px_1fr_auto] px-16 py-12 text-blue-7'
});

const ResultTile = () => {
  return (
    <TileContainer>
      <FirstRow />
      <TileContent>
        <VehicleYMMTM />
        <PricingAndTerms />
        <ShippingAndGetItBy />
      </TileContent>
    </TileContainer>
  );
};

interface ResultTileWithProviderProps {
  tileData?: TileData;
}

const ResultTileWithProvider = ({ tileData }: ResultTileWithProviderProps) => {
  return tileData ? (
    <TileDataContextProvider tileData={tileData}>
      <ResultTile />
    </TileDataContextProvider>
  ) : (
    <SkeletonTile />
  );
};

export default withErrorBoundary(ResultTileWithProvider);
